import React from "react";
export default function Header() {
  return (
    <header className="flex items-center justify-between">
      <ul className="py-4 mx-auto flex items-center justify-center gap-8">
        <li>
          <a
            href="https://github.com/omgate23"
            target="_blank"
            rel="noreferrer"
          >
            <i class="fa-brands fa-github text-xl text-neutral-400 hover:text-white transition-all duration-200"></i>
          </a>
        </li>
        <li>
          <a
            href="https://linkedin.com/in/omgate"
            target="_blank"
            rel="noreferrer"
          >
            <i class="fa-brands fa-linkedin text-xl text-neutral-400 hover:text-white transition-all duration-200"></i>
          </a>
        </li>
        <li>
          <a
            href="https://twitter.com/om_gate"
            target="_blank"
            rel="noreferrer"
          >
            <i class="fa-brands fa-twitter text-xl text-neutral-400 hover:text-white transition-all duration-200"></i>
          </a>
        </li>
      </ul>
    </header>
  );
}
